<template>
  <div>
    <div class="mb-8"></div>
    <section class="flex flex-col-reverse md:flex-row container mx-auto">
      <!-- Image -->
      <div class="flex w-full md:w-3/5 items-center mx-auto">
        <img alt="logo" class="w-full" src="https://photo-public.s3.amazonaws.com/suf/profile/register-user.jpg" />
      </div>

      <!-- Login Form -->
      <div class="flex flex-col items-center w-full md:w-2/5 mx-auto">
        <div class="w-full md:w-3/4">
          <h2 class="px-8 text-2xl mb-2 font-semibold">
            {{ $t("Forms.login_account") }}
          </h2>

          <LoginForm></LoginForm>

          <div class="px-4">
            <p class="with-line text-center">
              <span class="bg-white">{{
              $t("Forms.are_you_new")
            }}</span>
            </p>

            <div class="flex flex-col justify-center px-8 py-4 mb-4">
              <router-link :title="$t('Forms.sign_in')" class="
                  cursor-pointer
                  w-full
                  text-center
                  uppercase
                  p-2
                  border border-newxcaret-blue
                  bg-white
                  text-newxcaret-blue
                  rounded-full
                  my-4
                  text-sm
                  tracking-wider
                " :to="{ name: 'register' }">{{ $t("Forms.sign_in") }}</router-link>
              <p class="text-xs text-grey font-semibold" v-html="$t('Forms.terms_of_use')"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "@components/validators/index.js";
import LoginForm from "@forms/auth/Login.vue";

export default {
  props: [],
  mixins: [],
  components: { LoginForm },
  data: () => ({}),
  watch: {},
  methods: {},
  mounted() { },
};
</script>